import type { OrderLineInput, SchemeEntitlement } from '@api/b2b';
import type { DataSheetColumn } from '@components/ui/DataSheet';
import { NumberInput } from '@mantine/core';
import React from 'react';

import styles from './b2b.module.css';

/**
 * The Free column beside Quantity: a quantity box on each product that can be taken free under a
 * scheme the order earns, a dash on every other row. Shared by the order form and the brand's review.
 */
export function freeColumn<T extends { productId: string; name: string }>(
    eligible: Map<string, SchemeEntitlement>,
    picks: OrderLineInput[],
    onChange: (picks: OrderLineInput[]) => void,
): DataSheetColumn<T> {
    const qty = new Map(picks.map((p) => [p.productId, p.quantity]));
    return {
        key: 'free',
        header: 'Free',
        width: 110,
        sortable: false,
        filterable: false,
        render: (_v, row) => {
            const scheme = eligible.get(row.productId);
            if (!scheme) return <span className={styles.muted}>—</span>;
            return (
                <NumberInput
                    size="xs"
                    min={0}
                    allowDecimal={false}
                    className={styles.qtyInput}
                    value={qty.get(row.productId) ?? 0}
                    onChange={(v) => {
                        const n = Number(v) || 0;
                        onChange([...picks.filter((p) => p.productId !== row.productId), ...(n > 0 ? [{ productId: row.productId, quantity: n }] : [])]);
                    }}
                    title={`Free under ${scheme.schemeName}`}
                    aria-label={`Free ${row.name}`}
                />
            );
        },
    };
}
